<template>
  <div class="recordPage">
    <leftTree />
    <!--  v-show="isShow" -->
    <Btn :scopeId="scopeId" />
    <!-- 因为flex导致横向滚动条失效 这里使用动态计算属性 -->
    <rightContent style="width:calc(100% - 300px)"/>
  </div>
</template>

<script>

import bus from '@/utils/bus.js'


import leftTree from './components/LeftTree.vue';
import rightContent from './components/RightContent.vue';
import Btn from './components/PointSeting.vue';
export default {
  components: {
    leftTree,
    rightContent,
    Btn
  },
  data() {
    return {
      isShow: false,
      scopeId:''
    }
  },
  mounted() {
    bus.$on('nodeClickFn', obj => {
      if (obj.id === 'all') {
        this.isShow = false
      } else {
        this.isShow = true;
        this.scopeId = obj.scopeId
      }
    })
    this.scopeId = (this.$store.getters.SchemaTree && this.$store.getters.SchemaTree[0]) ? this.$store.getters.SchemaTree[0].scopeId : null
  }
}
</script>

<style lang="scss" scoped>
.recordPage {
  height: 100%;
  display: flex;
  position: relative;
  padding-right: 15px;
  box-sizing: border-box;
}
</style>